import { moduleIdProp } from 'root/src/client/logic/route/lenses'
import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { viewFormFullWidth } = formModuleLenses

export default (state, props) => viewFormFullWidth(
	moduleIdProp(props), moduleDescriptions,
)
